import { Reducer } from 'redux';
import { produce } from 'immer';

import { CONTAINER_TYPES, ContainerState } from './types';

export const INITIAL_STATE: ContainerState = {
  containerContext: {},
};

const reducer: Reducer<ContainerState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case CONTAINER_TYPES.GET_CONTAINER_DATA:
        draft.containerContext = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
